var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.623 2c.33 2.838 1.916 4.53 4.674 4.71v3.192c-1.598.156-2.998-.366-4.626-1.35v5.97c0 7.585-8.278 9.955-11.606 4.519-2.139-3.499-.83-9.637 6.031-9.883v3.366a9.926 9.926 0 0 0-1.592.39c-1.526.516-2.39 1.482-2.15 3.187.462 3.264 6.458 4.23 5.959-2.149V2.006h3.31V2Z",
    fill: "currentColor"
  })));
};
export default SvgTiktok;